// import React from "react";
// import moment from "moment";

// export default function list({ info, upcomming }) {
//   // console.log("INFO", info);
//   return <ul>{iterate(info, upcomming)}</ul>;
// }

// function iterate(data, flag) {
//   if (!data) return;
//   const bgColor = flag ? { backgroundColor: "#ffe66d" } : {};
//   return (
//     <>
//       {data.map((person, index) => {
//         Old(person.dob);
//         return (
//           <li key={index}>
//             <div className="flex">
//               <div className="title">
//                 <p className="name">
//                   <strong>{person.name}</strong>
//                 </p>
//                 <p className="name">
//                   {person.dob && moment(person.dob).format("DD-MMM")}
//                 </p>
//               </div>
//             </div>
//           </li>
//         );
//       })}
//     </>
//   );
// }

// // how old the person is
// function Old(personAge) {
//   let year = new Date(personAge).getFullYear();
//   let currentYear = new Date().getFullYear();
//   // console.log(currentYear)

//   let age = currentYear - year;
//   // console.log(age)
//   return age;
// }

import React from 'react';
import moment from 'moment';

export default function BirthdayList({ info = [], upcomming = false }) {
  return (
    <ul className='list-unstyled'>
      {info.length > 0 ? (
        info.map((person, index) => {
          const dob = person.dob ? new Date(person.dob) : null;
          // const age = getAge(dob);
          return (
            <li key={index} className='mb-2'>
              <div
                className={`card shadow-sm border-0 ${
                  upcomming ? 'bg-warning bg-opacity-25' : 'bg-light'
                }`}
              >
                <div className='card-body d-flex align-items-center justify-content-between py-2 px-3'>
                  <div>
                    <h6
                      className='card-title mb-1 fw-semibold text-dark'
                      style={{ fontSize: '0.95rem' }}
                    >
                      {person.name}
                    </h6>
                    {dob && (
                      <p
                        className='card-text mb-0 text-muted'
                        style={{ fontSize: '0.82rem' }}
                      >
                        🎂 {moment(dob).format('DD MMM')}
                      </p>
                    )}
                  </div>
                  {upcomming && (
                    <span
                      className='badge bg-warning text-dark'
                      style={{ fontSize: '0.75rem' }}
                    >
                      Upcoming
                    </span>
                  )}
                </div>
              </div>
            </li>
          );
        })
      ) : (
        <li className='text-muted text-center small'>No birthdays found.</li>
      )}
    </ul>
  );
}

// function getAge(dob) {
//   if (!dob) return '';
//   const birthDate = new Date(dob);
//   const today = new Date();
//   let age = today.getFullYear() - birthDate.getFullYear();
//   const hasHadBirthdayThisYear =
//     today.getMonth() > birthDate.getMonth() ||
//     (today.getMonth() === birthDate.getMonth() &&
//       today.getDate() >= birthDate.getDate());
//   if (!hasHadBirthdayThisYear) {
//     age--;
//   }
//   return age;
// }
